import { GetterTree } from "vuex";
import { RootState } from "../types";
import { MyCourseState } from "./types";

export const getters: GetterTree<MyCourseState, RootState> = {};
